<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('tank_manufacturers_specs.create')"
                                @invoke-method="invokeMethod($event)"
                                action="showTankManufacturersSpec"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetTankManufacturersSpecs()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="tank_manufacturers_specs" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showTankManufacturersSpec(props.item)">
                                <td>{{ props.item.manufacturer_id }}</td>
                                <td>{{ props.item.tank_name }}</td>
                                <td>{{ props.item.tank_type_id }}</td>
                                <td>{{ props.item.def_us_gallons }}</td>
                                <td>{{ props.item.metric_diameter }}</td>
                                <td>{{ props.item.metric_height }}</td>
                                <td>{{ props.item.metric_width }}</td>
                                <td>{{ props.item.metric_length }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="tank_manufacturers_spec"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="tank_manufacturers_spec_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{
                            currObjField("tank_spec_id") ? $t("lang.edit_tank_manufacturers_spec") : $t("lang.add_tank_manufacturers_spec")
                        }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeTankManufacturersSpecDialog"
                            :dialog-status="tank_manufacturers_spec_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="tank_manufacturers_spec">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            :focus="tank_manufacturers_spec_dialog"
                                            v-model="tank_manufacturers_spec.manufacturer_id"
                                            :label="$t('lang.manufacturer_id')"
                                            :items="manufacturer_id"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('tank_manufacturers_spec.manufacturer_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturers_spec.tank_name"
                                            :label="`${$t('lang.tank_name')} *`"
                                            :counter="showCounter(tank_manufacturers_spec.tank_name, 'tank_manufacturers_spec.tank_name')"
                                            :rules="ifValid('tank_manufacturers_spec.tank_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="tank_manufacturers_spec.tank_type_id"
                                            :label="$t('lang.tank_type_id')"
                                            :items="tank_type_id"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('tank_manufacturers_spec.tank_type_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturers_spec.def_us_gallons"
                                            :label="`${$t('lang.def_us_gallons')} *`"
                                            :counter="showCounter(tank_manufacturers_spec.def_us_gallons, 'tank_manufacturers_spec.def_us_gallons')"
                                            :rules="ifValid('tank_manufacturers_spec.def_us_gallons')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturers_spec.metric_diameter"
                                            :label="$t('lang.metric_diameter')"
                                            :counter="showCounter(tank_manufacturers_spec.metric_diameter, 'tank_manufacturers_spec.metric_diameter')"
                                            :rules="ifValid('tank_manufacturers_spec.metric_diameter')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturers_spec.metric_height"
                                            :label="$t('lang.metric_height')"
                                            :counter="showCounter(tank_manufacturers_spec.metric_height, 'tank_manufacturers_spec.metric_height')"
                                            :rules="ifValid('tank_manufacturers_spec.metric_height')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturers_spec.metric_width"
                                            :label="$t('lang.metric_width')"
                                            :counter="showCounter(tank_manufacturers_spec.metric_width, 'tank_manufacturers_spec.metric_width')"
                                            :rules="ifValid('tank_manufacturers_spec.metric_width')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_manufacturers_spec.metric_length"
                                            :label="$t('lang.metric_length')"
                                            :counter="showCounter(tank_manufacturers_spec.metric_length, 'tank_manufacturers_spec.metric_length')"
                                            :rules="ifValid('tank_manufacturers_spec.metric_length')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('tank_spec_id')" color="error" @mouseup.left="$refs.delete_tank_manufacturers_spec.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeTankManufacturersSpecDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            color="success"
                            @mouseup.left="modifyTankManufacturersSpec(currObjField('tank_spec_id') ? 'patch' : 'post', currObjField('tank_spec_id'))"
                            >{{ $t("lang.save") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_tank_manufacturers_spec"
                :heading="$t('lang.delete_tank_manufacturers_spec')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyTankManufacturersSpec('delete', currObjField('tank_spec_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                {
                    text: this.$t("lang.manufacturer_id"),
                    sortable: false,
                    width: "12%",
                },
                {
                    text: this.$t("lang.tank_name"),
                    sortable: false,
                    width: "12%",
                },
                {
                    text: this.$t("lang.tank_type_id"),
                    sortable: false,
                    width: "12%",
                },
                {
                    text: this.$t("lang.def_us_gallons"),
                    sortable: false,
                    width: "12%",
                },
                {
                    text: this.$t("lang.metric_diameter"),
                    sortable: false,
                    width: "12%",
                },
                {
                    text: this.$t("lang.metric_height"),
                    sortable: false,
                    width: "12%",
                },
                {
                    text: this.$t("lang.metric_width"),
                    sortable: false,
                    width: "12%",
                },
                {
                    text: this.$t("lang.metric_length"),
                    sortable: false,
                    width: "12%",
                },
            ],

            tank_manufacturers_spec: {
                manufacturer_id: "",
                tank_name: "",
                tank_type_id: "",
                def_us_gallons: "",
                metric_diameter: "",
                metric_height: "",
                metric_width: "",
                metric_length: "",
            },
            current_obj: null,
            filter: {
                search: "",

                page_size: 0,
                page_num: 0,
            },
            tank_manufacturers_spec_dialog: false,
            mobile_list: [
                {
                    title: this.$t("lang.add_new"),
                    action: "showTankManufacturersSpec",
                },
                {
                    title: this.$t("lang.refresh"),
                    action: "dbGetTankManufacturersSpecs",
                },
            ],
            dbGetTankManufacturersSpecs: _.debounce(this.getTankManufacturersSpecs, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchTankManufacturer", {
                url: "tank_manufacturers_spec",
                method: "get",
                stateProperty: "tank_manufacturers_specs",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_manufacturers_specs) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchTankManufacturer", {
                url: "tank_manufacturers_specs",
                method: "get",
                stateProperty: "tank_manufacturers_specs",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_manufacturers_specs) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_tank_manufacturers_spec: (state) => state.validation.rules_tank_manufacturers_spec,
            default_filter: (state) => state.tank_manufacturers.tank_manufacturers_specs_filter,
            page: (state) => state.tank_manufacturers.page,
            tank_manufacturers_specs: (state) => state.tank_manufacturers.tank_manufacturers_specs,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closeTankManufacturersSpecDialog() {
            this.tank_manufacturers_spec_dialog = false;
            this.$refs.delete_tank_manufacturers_spec.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getTankManufacturersSpecs() {
            this.startLoader();
            this.$store
                .dispatch("fetchTankManufacturer", {
                    url: "tank_manufacturers_specs",
                    method: "get",
                    stateProperty: "tank_manufacturers_specs",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.tank_manufacturers_spec_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyTankManufacturersSpec(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("tank_manufacturers_spec")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchTankManufacturer", {
                                pk: "tank_spec_id",
                                id: id,
                                url: `tank_manufacturers_specs/${id ? id : ""}`,
                                method: method,
                                stateProperty: "tank_manufacturers_specs",
                                mutate: true,
                                body: this.tank_manufacturers_spec,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeTankManufacturersSpecDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showTankManufacturersSpec(item = null) {
            this.current_obj = item;

            if (this.$refs.tank_manufacturers_spec) item ? this.$refs.tank_manufacturers_spec.resetValidation() : this.$refs.tank_manufacturers_spec.reset();

            this.$nextTick(() => {
                this.assignObj(this.tank_manufacturers_spec, item, this.rules_tank_manufacturers_spec);
                this.tank_manufacturers_spec_dialog = true;
            });
        },
    },
};
</script>
